import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Box, Typography, Divider, Button, InputBase, Grid } from "@mui/material";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useCurrentState } from "../hooks";
import { BRANCHES_API, BASE_INFOS_API, PROFILES_API } from "../api";
import { addNewMessage, setPageTitle } from "../slice";
import BaseRadio from "../components/all-inputs/BaseRadio";
import CenterAccordions from "../components/CenterAccordions";
import Select from "../components/Select";

function SelectCenter() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const updateUserStatus = useCurrentState();
  const [availableBranches, setAvailableBranches] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [provinceId, setProvinceId] = useState();
  const [cityId, setCityId] = useState("");
  const [search, setSearch] = useState("");
  const [filters, setFilters] = useState("");
  const [selectedCenter, setSelectedCenter] = useState("");

  const { mutate: getCitiesByProvinceId } = useMutation(
    (id) => BASE_INFOS_API.GetCitiesByProvinceId(id),
    {
      onSuccess: ({ data }) => {
        //todo:in qsmt ham byd payam haye smt server handle beshan
        if (data.success) {
          setCities(data.data);
        }
      },
    }
  );

  const { mutate: assignBranchToProfile } = useMutation(
    (id) => PROFILES_API.AssignBranchToProfile(id),
    {
      onSuccess: async ({ data }) => {
        //todo:in qsmt ham byd payam haye smt server handle beshan
        if (data.success) {
          updateUserStatus();
          queryClient.refetchQueries({
            queryKey: ["getUserInfo"],
            type: "active",
            exact: true,
          });
        }
      },
      onError: ({
        response: {
          data: { message },
        },
      }) => {
        dispatch(
          addNewMessage({
            id: "fail-on-assignBranchToProfile",
            text: message,
            type: "error",
          })
        );
      },
    }
  );

  const handleSearch = () => {
    setFilters(`search=${search}&provinceId=${provinceId}&cityId=${cityId}`);
    setSelectedCenter("");
  };

  const handleSelectProvinces = (event) => {
    setProvinceId(event.target.value);
    setCityId("");
    setSelectedCenter("");
  };

  const handleNextLevel = () => {
    assignBranchToProfile(selectedCenter);
  };

  useQuery(["getAvailable", filters], (filtres) => BRANCHES_API.GetAvailableBranches(filters), {
    onSuccess: ({ data }) => {
      if (data.success) {
        setAvailableBranches(data.data);
      } else {
        //todo:inja byd error ha handle beshan
      }
    },
  });

  useQuery(["getProvinces"], () => BASE_INFOS_API.GetProvincesByCountryId(1), {
    onSuccess: ({ data }) => {
      if (data.success) {
        setProvinces(data.data);
      } else {
        //todo:inja byd error ha handle beshan
      }
    },
  });

  useEffect(() => {
    if (provinceId !== undefined) {
      getCitiesByProvinceId(provinceId);
    }
  }, [provinceId, getCitiesByProvinceId]);

  useEffect(() => {
    dispatch(setPageTitle(""));
  }, [dispatch]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      justifyContent="flex-end"
      py="4vw"
      px="7vw"
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="flex-end"
        width={{ xs: "100%", xl: "95%" }}
      >
        <Typography variant="h2" textAlign="justify">
          متقاضی گرامی، شما می توانید جهت بهرمندی از خدمات همسان‌یابی، اطلاعات تکمیل شده خود را به
          هر یک از مراکز همسان‌گزینی زیر ارسال نمایید. انتخاب مرکز مناسب (در شهر محل سکونت شما، در
          دانشگاه محل تحصیل شما و ...) پیگیری پرونده شما را تسهیل خواهد کرد.
        </Typography>
        <Box my={3} width="100%">
          <Divider />
        </Box>
        <Typography variant="h1" textAlign="right">
          می خواهم مرکز را خودم انتخاب کنم
        </Typography>
        <Typography variant="h2" my={2} textAlign="right">
          لطفا با توجه به استان و شهر محل سکونت خود، مرکز همسان‌گزینی را انتخاب نمایید.
        </Typography>
      </Box>
      <Grid container flexDirection="row-reverse" width={{ xs: "100%", xl: "95%" }}>
        <Grid item xs={12} sm={4.7} xl={4.65} sx={Style.itemGrid}>
          <Select
            label="استان"
            name="provinces"
            idKey="id"
            labelKey="name"
            value={provinceId}
            data={provinces}
            onChange={handleSelectProvinces}
            flex={7}
            labelFlex={5}
          />
        </Grid>
        <Grid item xs={12} sm={4.7} sx={Style.itemGrid} mt={{ xs: 1, sm: 0 }} mr={{ xs: 0, sm: 2 }}>
          <Select
            label="شهر"
            name="cities"
            idKey="id"
            labelKey="name"
            value={cityId}
            data={cities}
            onChange={(event) => setCityId(event.target.value)}
            flex={7}
            labelFlex={5}
          />
        </Grid>
      </Grid>
      <Box
        display="flex"
        flexDirection={{ xs: "column-reverse", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-end", sm: "center" }}
        width={{ xs: "100%", xl: "95%" }}
        my={2}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          boxSizing="border-box"
          width={{ xs: "100%", sm: "57%", md: "57%", xl: "58.7%" }}
          bgcolor="#FAFAFA"
          p={1}
          borderRadius={4}
          mr={{ xs: 0, sm: 2 }}
        >
          <Button variant="s1" onClick={handleSearch}>
            جستجو کن
          </Button>
          <InputBase
            sx={{
              direction: "rtl",
              border: "none !important",
              flex: 1,
              fontSize: "0.9rem",
              boxSizing: "border-box",
              paddingRight: "0.5rem",
              "input::placeholder": {
                color: "#4C466F",
              },
            }}
            placeholder="جستجو مرکز"
            name="SearchInCenters"
            onChange={(event) => setSearch(event.target.value)}
          />
        </Box>
        <Typography variant="h1" textAlign="right" mb={{ xs: 1, sm: 0 }}>
          لیست مراکز
        </Typography>
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        width={{ xs: "100%", xl: "95%" }}
        justifyContent="flex-start"
        alignItems="center"
      >
        {availableBranches.map((branch) => (
          <Grid
            display="flex"
            container
            flexDirection="row"
            justifyContent="flex-end"
            alignItems="center"
            key={branch.id}
          >
            <Grid
              item
              xs={9.5}
              sm={11}
              display="flex"
              flexDirection="row"
              justifyContent="flex-end"
              alignItems="center"
            >
              <CenterAccordions
                id={branch.id}
                title={`${branch.name}`}
                details={branch.cvSummary}
              />
            </Grid>
            <Grid item xs={2.5} sm={1}>
              <BaseRadio
                onClick={() => setSelectedCenter(branch.id)}
                checked={selectedCenter === branch.id}
              />
            </Grid>
          </Grid>
        ))}
      </Box>
      <Box
        display="flex"
        flexDirection="row-reverse"
        alignItems="center"
        justifyContent="center"
        width="100%"
        my={5}
      >
        <Button variant="m1" sx={{ width: "165px", marginLeft: "5px" }} onClick={handleNextLevel}>
          بعدی
        </Button>
        <Button variant="m2" style={{ marginRight: "5px" }} onClick={() => navigate("/welcome")}>
          انصراف
        </Button>
      </Box>
    </Box>
  );
}

const Style = {
  itemGrid: {
    boxSizing: "border-box",
    paddingLeft: { xs: 0, sm: "0.5rem", md: "1rem", lg: "1rem" },
    marginBottom: "0.7rem",
  },
};

export default SelectCenter;
